import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { AuditorResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post, postEmpty } from "./common";

export const auditor = {
    record(data: typeof Requests.Auditor.Record.Input) {
        return post<typeof data, AuditorResponseTypes.Record>(`/auditor/record`, data);
    },
    create(data: typeof Requests.Auditor.Create.Input) {
        return post<typeof data>("/auditor/create", data);
    },
    obtain(id: string) {
        return get<AuditorResponseTypes.Obtain>(`/auditor/obtain/${id}`);
    },
    delete(id: string) {
        return postEmpty(`/auditor/delete/${id}`);
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Auditor.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/auditor/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
    dev: {
        masquerade(id: string) {
            return get<AuditorResponseTypes.Masquerade>(`/dev/auditor/masquerade/${id}`);
        },
    },
};
